import { render, staticRenderFns } from "./CompletedRFP.vue?vue&type=template&id=427adf74"
import script from "./CompletedRFP.vue?vue&type=script&lang=js"
export * from "./CompletedRFP.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports